module.exports = __webpack_public_path__ + "media/src/images/styleguide/default_giftcard-39a15a8067e364130e8674a56a5a3ca6.png";